// Recent searches (per device + per user, localStorage). Two kinds of entries:
// typed queries and tapped results (member / church / group) so a user can jump
// straight back to them from the search bar.
const KEY = "yalola.recentSearches";
const MAX = 10;

const storeKey = (userId) => `${KEY}.${userId || "anon"}`;

export const getRecent = (userId) => {
  try { return JSON.parse(localStorage.getItem(storeKey(userId)) || "[]"); } catch { return []; }
};

const save = (userId, items) => {
  try { localStorage.setItem(storeKey(userId), JSON.stringify(items.slice(0, MAX))); } catch { /* noop */ }
  return items.slice(0, MAX);
};

export const entryKey = (e) => (e.kind === "query" ? `q:${(e.q || "").toLowerCase()}` : `${e.kind}:${e.id}`);

const push = (userId, entry) => {
  const k = entryKey(entry);
  const rest = getRecent(userId).filter((e) => entryKey(e) !== k);
  return save(userId, [{ ...entry, ts: Date.now() }, ...rest]);
};

export const addRecentQuery = (userId, q) => {
  const v = (q || "").trim();
  return v.length >= 2 ? push(userId, { kind: "query", q: v }) : getRecent(userId);
};

// kind: user | church | group ; img = avatar / logo url (already resolvable), sub = city…
export const addRecentEntity = (userId, { kind, id, name, img, sub }) =>
  push(userId, { kind, id, name, img: img || null, sub: sub || null });

export const removeRecent = (userId, key) => save(userId, getRecent(userId).filter((e) => entryKey(e) !== key));

export const clearRecent = (userId) => save(userId, []);

export const recentPath = (e) => ({ user: `/profile/${e.id}`, church: `/churches/${e.id}`, group: `/groups/${e.id}` }[e.kind] || `/search?q=${encodeURIComponent(e.q || "")}`);
